import { Injectable, Output, EventEmitter } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class FooterService {
  constructor(
    private http: HttpClient) {
  }

  GetFooterDetails(): Observable<any> {
    //appApiResources.GetFooterListAPI Will update the UI after getting the fixed endpint for xml
    return this.http.get(`${environment.apiBaseUrl}/ShoppingCart/FooterXML`, {
      responseType: 'text'
    }).pipe(map((res) => { return res }));
  }
}


// WEBPACK FOOTER //
// ./src/app/core/services/footer.services.ts